import Fwd from '@mui/icons-material/FastForward'
import Rwd from '@mui/icons-material/FastRewind'
import PendingI from '@mui/icons-material/Remove'
import { Tooltip } from '@mui/material'

interface ICFDIMovementProps {
  type: string
  addTooltip?: boolean
  returnLabel?: boolean
}

const CFDIMovement = ({
  type,
  addTooltip,
  returnLabel,
}: ICFDIMovementProps) => {
  const label = type === 'I' ? 'Ingreso' : type === 'E' ? 'Egreso' : 'Pendiente'
  const className =
    type === 'I' ? 'income' : type === 'E' ? 'egress' : 'pending'
  const Icon = type === 'I' ? Rwd : type === 'E' ? Fwd : PendingI

  return (
    <div className="status-container movement-type">
      {!returnLabel && addTooltip && (
        <Tooltip title={label}>
          <Icon className={`status-icon ${className}`} color="inherit" />
        </Tooltip>
      )}
      {!addTooltip && (
        <Icon className={`status-icon ${className}`} color="inherit" />
      )}
      {returnLabel && label}
    </div>
  )
}

export default CFDIMovement
